import { createContext, useEffect, useState } from 'react';
import { InvoiceResponse, Transaction, Invoice, Merchant, Order } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type InvoiceContextProps = {
    transaction: Transaction;
    invoice: Invoice;
    merchant: Merchant;
    order: Order;
    isLoading: boolean;
    loadInvoice: (token: string) => Promise<void>;

}

export const InvoiceContext = createContext({} as InvoiceContextProps);
export const TransactionsContext = createContext({} as InvoiceContextProps);

export const InvoiceProvider = ({ children }: any) => {

    const [transaction, setTransaction] = useState<Transaction>(null);
    const [invoice, setInvoice] = useState<Invoice>(null);
    const [merchant, setMerchant] = useState<Merchant>(null);
    const [order, setOrder] = useState<Order>(null);

    const [isLoading, setIsLoading] = useState<boolean>(true);



    const loadInvoice = async (token: string) => {
        try {

            const resp = await topApi.get<InvoiceResponse>('/invoice/' + token);
            if (resp.status == 200) {
                setMerchant(resp.data.merchant);
                setTransaction(resp.data.transaction);
                setInvoice(resp.data.invoice);
                setOrder(resp.data.order);
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
        }

    }



    return (
        <InvoiceContext.Provider value={{
            merchant,
            transaction,
            invoice,
            order,
            isLoading,
            loadInvoice
        }}>
            {children}
        </InvoiceContext.Provider>
    );
}